import React, { useState } from 'react';
import { AppTableCard } from '../../../../../Components/TableKit';

const monthCodes = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const monthLetters = ['E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];

const BLUE = '#1565C0';

const getBadgeColor = (value) => {
    const num = Number(value);
    if (num === 1) return '#22c55e';  // verde - al corriente
    if (num === 2) return '#f59e0b';  // ámbar
    if (num >= 3 && num <= 5) return '#f97316'; // naranja
    if (num >= 6) return '#ef4444';   // rojo - mora severa
    return '#94a3b8';                 // gris - otros
};

const MonthBadge = ({ value }) => {
    if (value === undefined || value === null || String(value).trim() === '') return null;
    const bg = getBadgeColor(value);
    return (
        <span
            style={{
                backgroundColor: bg,
                color: '#fff',
                borderRadius: '9999px',
                width: '28px',
                height: '28px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.8rem',
                fontWeight: 700,
                boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
            }}
        >
            {value}
        </span>
    );
};

const DetailField = ({ label, value }) => (
    <div>
        <span className="text-600 text-xs">{label}:</span>
        <span className="ml-1 font-medium text-sm">{value || '-'}</span>
    </div>
);

/**
 * BuroPaymentHistoryTK
 *
 * @param {Array}  customerService - Array of payment history line items
 * @param {string} name            - Section title
 * @param {string} [variant]       - 'liquidado' | 'activo' | undefined (PF default)
 */
const BuroPaymentHistoryTK = ({ customerService = [], name = 'Historial de Pagos', variant }) => {
    const [expandedRows, setExpandedRows] = useState(new Set());

    const toggleRow = (id) => {
        setExpandedRows(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    if (!customerService || customerService.length === 0) {
        return (
            <div className="flex flex-column gap-2">
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-calendar text-sm" style={{ color: BLUE }} />
                    <span className="text-sm font-bold text-700" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        {name}
                    </span>
                </div>
                <AppTableCard animated={false}>
                    <table className="tk-table tk-table--compact">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="tk-empty">
                                        <i className="pi pi-inbox" />
                                        <span>No hay datos disponibles</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </AppTableCard>
            </div>
        );
    }

    return (
        <div className="flex flex-column gap-2">
            <div className="flex align-items-center gap-2">
                <i className="pi pi-calendar text-sm" style={{ color: BLUE }} />
                <span className="text-sm font-bold text-700" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {name}
                </span>
            </div>

            <AppTableCard animated={false}>
                <table className="tk-table tk-table--compact">
                    <thead>
                        <tr>
                            <th style={{ minWidth: '130px' }}>Línea de Crédito</th>
                            <th className="tk-th-center" style={{ fontSize: '0.6rem' }}>Créd. Máx.</th>
                            <th className="tk-th-center" style={{ fontSize: '0.6rem' }}>Monto Pagar</th>
                            <th className="tk-th-center" style={{ fontSize: '0.6rem' }}>Últ. Pago</th>
                            <th className="tk-th-center" style={{ fontSize: '0.6rem' }}>Saldo Vig.</th>
                            <th className="tk-th-center">Año</th>
                            {monthLetters.map((m, i) => (
                                <th key={i} className="tk-th-center" style={{ padding: '6px 2px', fontSize: '0.7rem', fontWeight: 800 }}>{m}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {customerService.map((line, lineIdx) => (
                            <React.Fragment key={line.id ?? lineIdx}>
                                {line?.representative?.data?.map((yearRow, yearIdx) => (
                                    <tr
                                        key={`${line.id}-${yearRow?.anio}`}
                                        style={{
                                            backgroundColor: lineIdx % 2 === 1 ? '#f0f7ff' : 'transparent',
                                            cursor: yearIdx === 0 ? 'pointer' : 'default',
                                        }}
                                    >
                                        <td style={{ padding: '6px 8px' }}>
                                            {yearIdx === 0 && (
                                                <div
                                                    className="flex align-items-center gap-2"
                                                    onClick={() => toggleRow(line.id)}
                                                >
                                                    <i
                                                        className={`pi ${expandedRows.has(line.id) ? 'pi-chevron-down' : 'pi-chevron-right'}`}
                                                        style={{ fontSize: '0.75rem', color: BLUE }}
                                                    />
                                                    <div className="flex flex-column">
                                                        <span className="font-medium text-900" style={{ fontSize: '0.75rem' }}>
                                                            {line?.representative?.name || line?.name}
                                                        </span>
                                                        {line?.representative?.descripcion && (
                                                            <span className="text-500" style={{ fontSize: '0.65rem' }}>{line.representative.descripcion}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                        <td className="tk-td-center" style={{ fontSize: '0.7rem', padding: '6px 4px' }}>{yearIdx === 0 ? (line?.valor2 || '-') : ''}</td>
                                        <td className="tk-td-center" style={{ fontSize: '0.7rem', padding: '6px 4px' }}>{yearIdx === 0 ? (line?.valor?.name || line?.valor || '-') : ''}</td>
                                        <td className="tk-td-center" style={{ fontSize: '0.7rem', padding: '6px 4px' }}>{yearIdx === 0 ? (line?.valor6 || '-') : ''}</td>
                                        <td className="tk-td-center" style={{ fontSize: '0.7rem', padding: '6px 4px' }}>{yearIdx === 0 ? (line?.valor3 || '-') : ''}</td>
                                        <td className="tk-td-center font-bold" style={{ fontSize: '0.75rem', padding: '6px 4px' }}>{yearRow?.anio}</td>
                                        {monthCodes.map((code, idx) => (
                                            <td key={idx} className="tk-td-center" style={{ padding: '4px 2px' }}>
                                                <MonthBadge value={yearRow?.[code]} />
                                            </td>
                                        ))}
                                    </tr>
                                ))}

                                {expandedRows.has(line.id) && (
                                    <tr>
                                        <td
                                            colSpan={18}
                                            style={{
                                                padding: '10px 16px',
                                                backgroundColor: lineIdx % 2 === 1 ? '#f0f7ff' : '#fafafa',
                                                borderBottom: '2px solid #e2e8f0',
                                            }}
                                        >
                                            <div className="flex align-items-center gap-2 mb-2 pb-2 border-bottom-1 surface-border">
                                                <i className="pi pi-info-circle text-sm" style={{ color: BLUE }} />
                                                <span className="text-sm font-semibold text-900">
                                                    {line?.representative?.name || line?.name} — Detalles
                                                </span>
                                            </div>
                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '0.5rem' }}>
                                                <DetailField label="Apertura" value={line?.valor5} />
                                                <DetailField label="Saldo Vigente" value={line?.valor3} />
                                                <DetailField label="Saldo Vencido" value={line?.valor4} />
                                                <DetailField label="Clave Obs." value={line?.valor7 || line?.clave_observacion} />

                                                {variant === 'liquidado' && (
                                                    <>
                                                        <DetailField label="Quita" value={line?.quita} />
                                                        <DetailField label="Dación" value={line?.dacion} />
                                                        <DetailField label="Quebranto" value={line?.quebranto} />
                                                    </>
                                                )}

                                                {variant === 'activo' && (
                                                    <>
                                                        <DetailField label="1-29 días" value={line?.saldo_vencido_de_1a29_dias} />
                                                        <DetailField label="30-59 días" value={line?.saldo_vencido_de_30a59_dias} />
                                                        <DetailField label="60-89 días" value={line?.saldo_vencido_de_60a89_dias} />
                                                        <DetailField label="90-119 días" value={line?.saldo_vencido_de_90a119_dias} />
                                                        <DetailField label="120-179 días" value={line?.saldo_vencido_de_120a179_dias} />
                                                        <DetailField label="180+ días" value={line?.saldo_vencido_de_180_dias_o_mas} />
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </AppTableCard>
        </div>
    );
};

export default BuroPaymentHistoryTK;
